import http from '../../../Utils/http';
const PricingEditor = {
  name: 'pricingEditor',
  state: {
    editorLoading: false,
    error: '',
    permissions: [
      'organization:view',
      'organization:create',
      'organization:delete',
      'organization:update',
    ],
    editorList: [],
    editorDetails: {},
    editorMessage: ''
  },
  reducers: {
    pricingEditorRequested(state) {
      return {
        ...state,
        editorLoading: true,
        error: '',
        editorMessage: ''
      };
    },
    pricingEditorReceived(state, payload) {
      return {
        ...state,
        editorLoading: false,
        editorList: payload,
        editorMessage: 'Changes have been saved.',
        error: '',
      }
    },
    pricingEditorRequestFailed(state, payload) {
      return {
        ...state,
        error: payload,
        editorMessage: '',
        editorLoading: false,
      };
    },

    editorDetailsRequested(state) {
      return {
        ...state,
        loading: true,
        error: '',
        message: ''
      };
    },
    editorDetailsReceived(state, payload) {
      return {
        ...state,
        loading: false,
        editorDetails: payload,
        error: '',
      }
    },
    editorDetailsFailed(state, payload) {
      return {
        ...state,
        error: 'error',
        editorDetails: {},
        loading: false,
      };
    },

  },
  effects: (dispatch) => ({
    async requestForPicingEditorList() {
      try {
        this.pricingEditorRequested();
        const response = await http.get(`savvy/plans/`);
        this.pricingEditorReceived(response.data.data.rows);
      } catch (err) {
        this.pricingEditorRequestFailed(err.response.data.error)
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: 'Invalid Credentials',
            open: true,
          },
        });
      }
    },
    async requestForPricingEditorDetails(data) {
      try {
        this.editorDetailsRequested();
        const response = await http.get(`savvy/plans/${data}`);
        this.editorDetailsReceived(response.data.data);
      } catch (err) {
        this.editorDetailsFailed(err.response.data.error)
        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: 'Invalid Credentials',
            open: true,
          },
        });
      }
    },
    async clearData() {
      this.editorDetailsReceived('');
    }
  }),
};

export default PricingEditor;